<template>
  <div>
    <div class="app-wrapper"
      :class="{ 'mobile': app.device === 'mobile', 'open-sidebar': !isCollapse, 'close-sidebar': isCollapse }"
      v-if="!hideMenu">
      <el-container>
        <i-navbar v-bind:isCollapse="isCollapse" @closeNavbar="closeNavbar" @openNavbar="openNavbar"></i-navbar>
        <el-container class="right-wrapper">
          <div class="header-wrapper">

            <i-header v-bind:isCollapse="isCollapse" @openNavbar="openNavbar" @closeNavbar="closeNavbar"></i-header>
          </div>
          <div v-if="showMerchantBar" class="company-info" :class="{ warning: auditStatus !== 0 }">
            <span>Hi，{{ (app.userLogin.businessType === '0' && auditStatus !== 0) ? app.userLogin.operatorEmail :
              app.userLogin.merchantName }}</span>
            <!-- 付款商户才显示 -->
            <div>
              <p v-if="app.userLogin.businessType === '0'" class="merchant-audit-info">
                <span
                  v-if="auditStatus === 1 || oldPayoutStatus===3">
                  <img src="@/assets/images/icon-waring.png" alt="" class="icon-img">
                  {{ $t('message.user.authNotCompleted') }}<span class="link" @click="toSupplement()">{{
                    $t('message.user.fillInfo') }} ></span></span>
                <span
                  v-else-if="oldPayoutStatus===1 || auditStatus === 2">
                  <img src="@/assets/images/icon-waring.png" alt="" class="icon-img">
                  {{ $t('message.user.authReviewing') }}</span>
                <span v-else-if="oldPayoutStatus===2 || auditStatus === 3">
                  <img src="@/assets/images/icon-waring.png" alt="" class="icon-img">
                  {{ $t('message.user.authFailed') }}<span class="link" @click="toSupplement()">{{
                    $t('message.user.modifyInfo') }} ></span></span>
              </p>
              <!-- 收单开通付款 -->
              <!-- 菜单的key -->
              <p v-if="app.userLogin.isAggregateMerchant && showpayoutStatus == 'payout'" class="merchant-audit-info">
                <span v-if="app.businessTypes && app.businessTypes.rejectedBusinessType">
                  <img src="@/assets/images/icon-waring.png" alt="" class="icon-img">
                  {{ $t('message.user.authFailed') }}<span class="link" @click="toSupplement()">{{
                    $t('message.user.modifyInfo') }} ></span></span>
                <span v-else-if="app.businessTypes && app.businessTypes.pendingBusinessTypes">
                  <img src="@/assets/images/icon-waring.png" alt="" class="icon-img">
                  {{ $t('message.user.authReviewing') }}</span>
                <span
                  v-else-if="app.businessTypes && (app.businessTypes.businessTypes || '').split(',').filter(Boolean).length === 1">
                  <img src="@/assets/images/icon-waring.png" alt="" class="icon-img">
                  {{ $t('message.user.authNotCompleted') }}<span class="link" @click="toSupplement()">{{
                    $t('message.user.fillInfo') }} ></span></span>
              </p>
              <!-- 人脸认证 -->
              <p v-if="(app.userLogin.businessType === '0' || showpayoutStatus == 'payout')" class="merchant-audit-info"
                style="margin-top: 5px;">
                <span v-if="app.jumioUser && app.jumioUser.faceAuthFlag === 0 && !app.jumioStatus">
                  <img src="@/assets/images/icon-waring.png" alt="" class="icon-img">
                  {{ $t('message.user.jumioNotCompleted') }}<span class="link" @click="toJumio()">{{
                    $t('message.user.fillInfo') }} ></span></span>
                <span v-else-if="app.jumioStatus && app.jumioStatus.approveStatus === 'waiting'">
                  <img src="@/assets/images/icon-pendding.png" alt="" class="icon-img">
                  {{ $t('message.user.autoNotPendding') }}，<span class="link" @click="toJumio('view')">{{
                    $t('message.tableCommon.see') }} ></span></span>
                <span v-else-if="app.jumioStatus && app.jumioStatus.approveStatus === 'fail'">
                  <img src="@/assets/images/icon-waring.png" alt="" class="icon-img">
                  {{ $t('message.user.authNotFass') }}，<span class="link" @click="toJumio()">{{
                    $t('message.user.modifyInfo') }} ></span></span>
              </p>
            </div>

          </div>
          <el-main class="main-wrapper">
            <div class="main-wrapper-inner">
              <router-view />
              <div v-if="checkAuditStatus && auditStatus !== 0" class="insufficient-permission">
                <EmptyComponent :empty-title="getAuditStatusTip()"
                  :empty-icon="require(auditStatus === 1 ? '@/assets/images/table/img-auth1.png' : '@/assets/images/table/img-auth.png')">
                  <el-button v-if="auditStatus === 3" class="margin-top-6" size="small" type="primary"
                    @click="toSupplement()">{{ $t('message.user.goRevise') }}</el-button>
                  <el-button v-else-if="auditStatus === 1" class="margin-top-6" size="small" type="primary"
                    @click="toSupplement()">{{ $t('message.user.goSupplement') }}</el-button>
                </EmptyComponent>
              </div>
            </div>
          </el-main>
        </el-container>
      </el-container>
    </div>
    <div v-if="hideMenu"><router-view /></div>
    <custom-message ref="auditCustomMessage" :cancelButtonText="alertCancelButtonText"
      :confirmButtonText="alertConfirmButtonText"></custom-message>
  </div>
</template>
<script>
import { mapGetters } from 'vuex';

import { getMerchantAudit } from '@/api/common/user';
import CustomMessage from '@/components/modal/message-box/custom-message.vue';
import EmptyComponent from '@/components/table/empty-component.vue';
import IHeader from '@/layout/base/components/iheader/index.vue';
import INavbar from '@/layout/base/components/inavbar/index.vue';
import Resize from '@/layout/base/mixin/resize';
import AccountInfo from '@/views/account/information/api/account-info';

export default {
  components: {
    IHeader,
    INavbar,
    CustomMessage,
    EmptyComponent,
  },
  mixins: [Resize],
  computed: {
    ...mapGetters([
      'app',
    ]),
    auditStatus() {
      const info = this.app.userLogin;
      // console.log('app.businessTypes', this.app.businessTypes);
      const status = info.merchantStatus;
      const audit = info.auditStatus;
      if (`${status}` === '4') { // 商户状态未启用
        if (!audit) { // 商户审核状态为空, 当前未完成身份认证。立即认证
          return 1;
        } else if (audit === 'waiting' || audit === 'processing') { // 商户审核状态为审核中
          return 2;
        } else if (audit === 'fail') { // 商户审核状态为审核失败
          return 3;
        }
      }
      return 0;
    },
    // 付款老用户用新字段兼容
    oldPayoutStatus() {
      // console.log('app.businessTypes222', this.app.businessTypes);
      if (this.app.businessTypes && this.app.businessTypes.rejectedBusinessType) {
        // 被拒绝
        return 2;
      } else if (this.app.businessTypes && this.app.businessTypes.pendingBusinessTypes) {
        // 审核中
        return 1;
      } else if (!this.app.businessTypes.businessTypes && !this.app.businessTypes.rejectedBusinessType && !this.app.businessTypes.pendingBusinessTypes) {
        // 需要开通
        return 3;
      }
      // 已完成
      return 4;
    },
    showpayoutStatus() {
      return this.$route.params && this.$route.params.type;
    },
  },
  data() {
    return {
      isCollapse: false,
      hideMenu: false,
      showMerchantBar: false,
      alertCancelButtonText: 'message.tableCommon.cancel',
      alertConfirmButtonText: 'message.common.confirm',
      checkAuditStatus: false,
      approveStatus: '',
      faceAuthFlag: null,
    };
  },
  methods: {
    openNavbar() {
      this.isCollapse = true;
    },
    closeNavbar() {
      this.isCollapse = false;
    },
    toSupplement() {
      this.$router.push({
        path: '/account/supplement/payout',
      });
    },
    toJumio(item) {
      console.log('item', this.showpayoutStatus);
      const businessType = this.showpayoutStatus || '';
      if (item) {
        this.$router.push({
          path: `/account/supplement/jumio?type=${item}&businessType=${businessType}`,
        });
      } else {
        this.$router.push({
          path: `/account/supplement/jumio?businessType=${businessType}`,
        });
      }
    },
    onShowAuditStatusAlert() {
      let confirmButtonText = 'message.user.goSupplement';
      let cancelButtonText = 'message.tableCommon.cancel';
      let content = 'message.user.goSupplementTips';
      if (this.auditStatus === 2) {
        cancelButtonText = '';
        confirmButtonText = 'message.common.close';
        content = 'message.user.auditWaitingTips';
      } else if (this.auditStatus === 3) {
        confirmButtonText = 'message.user.goRevise';
        content = 'message.user.goReviseTips';
      }
      this.alertCancelButtonText = cancelButtonText;
      this.alertConfirmButtonText = confirmButtonText;

      this.$nextTick(() => {
        this.$refs.auditCustomMessage.openDefaultModal({
          titleHtml: this.$t('message.common.prompt'),
          contentHtml: this.$t(content),
          onOkClick: (action, instance, done) => {
            done();
            if (this.auditStatus !== 2) {
              this.toSupplement();
            }
          },
        });
      });
    },
    getAuditStatusTip() {
      let tip = 'message.user.goSupplementTips';
      if (this.auditStatus === 2) {
        tip = 'message.user.auditWaitingTips';
      } else if (this.auditStatus === 3) {
        tip = 'message.user.goReviseTips';
      }
      return this.$t(tip);
    },
  },
  created() {
    // this.queryMerchantAudit();
    if (this.$route.meta.hideMenu) {
      this.hideMenu = true;
    } else {
      this.hideMenu = false;
    }
    this.checkAuditStatus = !!this.$route.meta.checkAuditStatus;
    this.showMerchantBar = this.$route.meta.showMerchantBar;
    // 监听商户审核状态事件
    this.$bus.$off('showAuditStatusAlert');
    this.$bus.$on('showAuditStatusAlert', () => {
      this.onShowAuditStatusAlert();
    });
  },
  mounted() {
  },
  watch: {
    '$route.path': {
      handler() {
        if (this.$route.meta.hideMenu) {
          this.hideMenu = true;
        } else {
          this.hideMenu = false;
        }
        this.checkAuditStatus = !!this.$route.meta.checkAuditStatus;
        this.showMerchantBar = this.$route.meta.showMerchantBar;
      },
    },
  },
};
</script>
<style lang="scss">
@import '~@/styles/menu.scss';
</style>
<style scoped lang="scss">
@import '~@/styles/variables.scss';

.right-wrapper {
  flex-direction: column;
  // padding-top: 70PX;
  min-height: 100vh;
}

.main-wrapper-inner {
  position: relative;
  // min-height: calc(100% - 60px);
  height: 100%;
  box-sizing: border-box;

  .insufficient-permission {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 100;
    background-color: white;
    display: flex;
    align-items: center;
    justify-content: center;

    ::v-deep .icon-empty {
      width: 200px;
      height: 200px;
      margin-bottom: 10px;
    }
  }
}

.app-wrapper {
  min-width: 1400px;
}

.header-wrapper {
  width: 100%;
  // position: fixed;
  // top: 0px;
  // left: 0px;
  padding-left: 24px;
  z-index: 1000;
  padding-bottom: 15px;
  padding-right: 20px;
  background-color: $color-white;
  box-sizing: border-box;
}

.company-info {
  display: flex;
  align-items: center;
  justify-content: space-between;
  // height: 50px;
  padding-top: 16px;
  padding-bottom: 16px;
  background: $color-balance-bg;
  font-size: 16px;
  font-weight: bold;
  color: $color-text-primary;
  padding-left: 60px;
  padding-right: 60px;
  margin-bottom: 20px;

  .merchant-audit-info {
    display: flex;
    align-items: center;
    //  font-family: PingFang-SC, PingFang-SC;
    font-weight: bold;
    font-size: 14px;
    // line-height: 36px;

    .link {
      color: $color-primary;
      cursor: pointer;
    }

    .icon-tixing {
      color: $color-danger;
    }
  }

  &.warning {
    background-color: #E7262A14;
  }
}

.main-wrapper {
  padding: 0px 60px 30px 60px;
  background-color: $color-white;
  box-sizing: border-box;
  overflow-y: scroll;
  height: calc(100vh - 200px);
}

@media screen and (max-width: 992px) {
  .app-wrapper {
    min-width: 0;
    width: 100vw;
  }

  .main-wrapper {
    padding: 0px 10px 30px 10px;
  }

  .header-wrapper {
    width: 100%;
    // position: fixed;
    // top: 0px;
    // left: 0px;
    padding: 0 15px;
    height: 50px;
  }
}

.icon-img {
  width: 22px;
  height: 22px;
  vertical-align: middle;
  margin-top: -2px;
}
</style>
